import React from "react";
import MealPolicy from "./meal_policy";
import styles from "./rate_plan_policies.module.css";
import CancellationBadge from "./cancellation_badge";

export default function RatePlanPolicies({ ratePlan }) {
  const { cancellationPolicy } = ratePlan;
  return (
    <div className={styles.mealContainer}>
      <MealPolicy mealPolicy={ratePlan.title} />

      <CancellationBadge cancellationPolicy={cancellationPolicy} />

      {/* <PoliciesInfo ratePlan={ratePlan} /> */}
    </div>
  );
}
